(function() {
    'use strict';
    var FrameworkCtrl = function($scope, $compile,ajaxCall, xmsNotificationFactory, $uibModalInstance) {
        $scope.ngModel = {};
        $scope.fnReplaceFrameworkForBusiness = function($event) {

            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH +
                "/framework/replaceFrameworkForBusiness?";
            var data    = $scope.ngModel;


            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    console.log("success!!! ");
                    var alertMessage = "Framework Replaced.";
                    xmsNotificationFactory.addObj({id: "replaceFramework", type: "success", bodyHtml: alertMessage, timeout:5});
                    $scope.cancel();
                },
                function(result) {
                    var alertMessage = "Error occurred. Please try again later.";
                    xmsNotificationFactory.addObj({id: "replaceFramework", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $scope.cancel();

                }
            );
            $event.preventDefault();
        }
        $scope.cancel = function(e) {
            if(angular.isDefined(e)){
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        }

    }
    FrameworkCtrl.$inject = ['$scope', '$compile', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance'];
    angular.module('app').controller('FrameworkCtrl', FrameworkCtrl);
}());
